<template>
    <div class="custom-modal export"
         @click="closeCustomModal()">

        <div class="custom-modal-window" style="min-height: 300px; max-width: 500px;" @click.stop>
            <div class="btn-close" @click="closeCustomModal()"></div>

            <div class="custom-modal-body">
                <h3>Välj kolumner att exportera</h3>
                <div @click="massToggle()" v-if="toggleState === 1" style="color: #00a870; font-weight: 600;" class="mb-3">Avmarkera alla</div>
                <div @click="massToggle()" v-if="toggleState === 0" style="color: #00a870; font-weight: 600;" class="mb-3">Markera alla</div>

                <div class="form-check mb-0" :key="'exportc'+index" v-for="(field, index) in settings.export_fields">
                    <input class="form-check-input" type="checkbox" :value="field.column" v-model="checkedNames" :id="'field_'+index">
                    <label class="form-check-label" :for="'field_'+index">{{ field.name }}</label>
                </div>

                <div class="d-flex justify-content-end mt-3">
                    <button class="btn btn-info me-2" @click="closeCustomModal()">Avbryt</button>
                    <button class="btn btn-primary" @click="download()">Exportera</button>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

import modaler from '../mixins/modaler'

export default {

    mixins: [
        modaler
    ],

    props: {
        settings: {
            required: true
        },
        query: {
            required: true
        },
        pagination: {
            required: true
        }
    },

    data () {
        return {
            checkedNames: [],
            toggleState: 1
        }
    },

    created () {
        this.checkAll()
    },

    methods: {
        massToggle () {
            if (this.toggleState === 1) {
                this.checkedNames = []
                this.toggleState = 0
                return
            }

            this.checkAll()
            this.toggleState = 1
        },

        checkAll () {
            this.checkedNames = this.settings.export_fields.map(f => f.column)
        },

        download () {
            const fields = this.settings.export_fields.filter(f => this.checkedNames.indexOf(f.column) !== -1)

            const form = document.createElement('form')
            form.method = 'POST'
            form.action = this.settings.url + '/export'

            const addInput = (name, value) => {
                const input = document.createElement('input')
                input.type = 'hidden'
                input.name = name
                input.value = value
                form.appendChild(input)
            }

            addInput('_token', document.querySelector('meta[name="csrf-token"]').content)
            addInput('fields', JSON.stringify(fields))
            addInput('query', JSON.stringify(this.query))
            addInput('pagination', JSON.stringify(this.pagination))

            document.body.appendChild(form)
            form.submit()
            document.body.removeChild(form)
        }
    }

}
</script>
